import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SimpleLogin from '../components/auth/SimpleLogin';
import SignUp from '../components/auth/SignUp';
import ResetPassword from '../components/auth/ResetPassword';
import AttendanceCheckIn from '../components/attendance/AttendanceCheckIn';
import PurchaseConfirmation from '../components/payment/PurchaseConfirmation';
import DonationForm from '../components/payment/DonationForm';
import DonationConfirmation from '../components/payment/DonationConfirmation';
import logo from '../assets/logo.png';
import { AuthContainer, AuthCard, Logo } from './App.styles';

function PublicRoutes() {
  return (
    <Routes>
        {/* Public routes that don't need auth card styling */}
        <Route path="/purchase/confirmation" element={<PurchaseConfirmation />} />
        <Route path="/confirmation" element={<PurchaseConfirmation />} />
        <Route path="/donation" element={<DonationForm />} />
        <Route path="/donation/success" element={<DonationConfirmation />} />

        {/* Auth routes that need the auth card styling */}
        <Route path="/login" element={
          <AuthContainer>
            <AuthCard
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Logo>
                <img src={logo} alt="Faith Insight Logo" />
                <h1>Faith Insight</h1>
                <p>Learning Portal</p>
              </Logo>
              <SimpleLogin />
            </AuthCard>
          </AuthContainer>
        } />
        <Route path="/signup" element={
          <AuthContainer>
            <AuthCard
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Logo>
                <img src={logo} alt="Faith Insight Logo" />
                <h1>Faith Insight</h1>
                <p>Learning Portal</p>
              </Logo>
              <SignUp />
            </AuthCard>
          </AuthContainer>
        } />
        <Route path="/reset-password" element={
          <AuthContainer>
            <AuthCard
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Logo>
                <img src={logo} alt="Faith Insight Logo" />
                <h1>Faith Insight</h1>
                <p>Learning Portal</p>
              </Logo>
              <ResetPassword />
            </AuthCard>
          </AuthContainer>
        } />
        <Route path="/attendance/checkin" element={<Navigate to="/login?redirect=%2Fattendance%2Fcheckin" replace />} />
        <Route path="/attendance/checkin/:sessionId" element={<AttendanceCheckIn />} />
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
  );
}

export default PublicRoutes;
